import {Injectable} from '@angular/core';

import {HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {BaseService} from './BaseService';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner'
import 'rxjs/add/operator/map';


@Injectable()
export class PoService {

    constructor(private http: HttpClient, private baseurl: BaseService, private spinnerService: Ng4LoadingSpinnerService) {

    }

    savePO(data) {
        let url: string = "/createpurchaseorder";
        let body = JSON.stringify(data);
        console.log("**##", body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    updatePO(data) {
        let url: string = "/updatepurchaseorder";
        let body = JSON.stringify(data);
        console.log("%%##", body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.put(this.baseurl.url + url + '/' + data.id, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    updateexecuteMail(data) {
        let url: string = "/updateexecuteMail";
        let body = JSON.stringify(data);
        console.log("%%##updateexecuteMail", body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
//        return this.http.put(this.baseurl.url + url + '/' + data.id, body, {headers}).map((res) => {
            res;
//            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    
    searchPO(data) {
        let url: string = "/searchpurchaseorder";
        let body = JSON.stringify(data);
        console.log(body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    findPObyid(id: number) {
        let url: string = "/findpurchaseorderid";
        let body = JSON.stringify({
            id: id
        });
        console.log("$$", body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    findaddress(id: number) {
        let url: string = "/searchpostaladdress";
        let body = JSON.stringify({
            exportCompanyid: id
        });
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {res; return res});
    }
    findcontact(id: number) {
        let url: string = "/searchcontact";
        let body = JSON.stringify({
            exportCompanyid: id
        });
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {res; return res});
    }
    generateexcelreport(data) {
        let url: string = "/generatepurchaseorderreport";
        let body = JSON.stringify({
            printType: 'EXCEL',
            purchaseOrderVO: data
        });
        console.log("body", data)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('responseType', 'arrayBuffer');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers, responseType: 'text'}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    generateproformareport(data, img) {
        let url: string = "/generatepurchaseorderreport";
        let body = JSON.stringify({
            printType: 'pdf',
            purchaseOrderVO: data,
            backimage: img
        });
        console.log(body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('responseType', 'arrayBuffer');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers, responseType: 'text'}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    generatePrint(data, img) {
        let url: string = "/generateInvoicePurchaseOrder";
        let body = JSON.stringify({
            printType: 'pdf',
            purchaseOrderVO: data,
            backimage: img
        });
        console.log(body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('responseType', 'arrayBuffer');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers, responseType: 'text'}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    getallstate() {
        let url: string = "/getallstate";
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        return this.http.get(this.baseurl.url + url, {headers}).map((res) => {res; return res});
    }
    generateESfile(data) {
        let url: string = "/generateEmailESFile";
        let body = JSON.stringify(data);
        console.log(body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8')
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }

    generateNonPaymentReport(data) {
        let url: string = "/generateNonPaymentReport";
        let body = JSON.stringify({
            printType: 'EXCEL',
            purchaseOrderVO: data
        });
        console.log("body", data)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('responseType', 'arrayBuffer');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers, responseType: 'text'}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }

    searchFileattachmentByCompanyCriteria(attach) {
        let url: string = "/searchFileattachmentByCompanyCriteria";
        let body = JSON.stringify(attach);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            return res;
        }).catch(
            (error: Response) => {
                return Observable.throw(error);
            });
    }
    performPOMailReminder (data) {
        let url: string = "/performPOMailReminder ";
        let body = JSON.stringify(data);
        console.log("**##", body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    
     updatePurchaseOrderBilltoAddress(data: any) {
        let url = '/updatePurchaseOrderBilltoAddress';
        let body = JSON.stringify(data);
        console.log(body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url , body, {headers}).map((res) => {
            res;
            console.log("res12", JSON.stringify(res));
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }
    
      updatePurchaseOrderDetails(data: any) {
        let url = '/updatePurchaseOrderDetails';
        let body = JSON.stringify(data);
        console.log(body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url , body, {headers}).map((res) => {
            res;
            console.log("res12", JSON.stringify(res));
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }
      generateSealSaleReport(data) {
        let url: string = "/generateSealSaleReport";
        let body = JSON.stringify({
            printType: 'EXCEL',
            purchaseOrderVO: data
        });
        console.log("body", data)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('responseType', 'arrayBuffer');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers, responseType: 'text'}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
}




// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/service/PurchaseOrderService.ts